import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import VConsole from 'vconsole';
// import BrowserLogger from 'alife-logger'
// import Package from '../../package.json'

// const { VUE_APP_ENV } = process.env
// const ENVIRONMENT = {
//   production: 'prod',
//   development: 'local',
//   test: 'daily',
//   realpre: 'pre'
// }

// 不是ip和localhost地址
// const prodTargetUrl = !/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(location.hostname) && location.hostname !== 'localhost'
// 错误上报环境启用
// const loggerConfigHandler = () => {
//   const bl = BrowserLogger.singleton({
//     pid: 'b3efcz0rox@60568d2b557946c',
//     appType: 'web',
//     imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
//     sendResource: true,
//     enableLinkTrace: true,
//     behavior: true,
//     environment: ENVIRONMENT[VUE_APP_ENV],
//     release: Package.version
//   })
//   bl.setConfig({
//     ignore: {
//       ignoreUrls: [
//         'https://obs.prod.ubanquan.cn/',
//         'https://ysf.nosdn.127.net/',
//         'https://d.alicdn.com/',
//         /.+?qiyukf.+/,
//         /.+?cnzz.+/
//       ],
//       ignoreApis: [/^umini.shujupie.com/, 'https://qiyukf.com/'],
//       ignoreErrors: [/^Script error\.?$/],
//       ignoreResErrors: []
//     }
//   })
// }
var initReportHandler = function initReportHandler() {
  // 非生产环境启用
  if (['test', 'dev'].some(function (x) {
    return window.location.hostname.includes(x);
  })) {
    new VConsole();
  }
  // 线上环境启用 tips:由于额度使用完开始收费暂停使用
  // if (VUE_APP_ENV === 'production' && prodTargetUrl) {
  //   loggerConfigHandler()
  // }
};
initReportHandler();